module.exports = __webpack_public_path__ + "static/noticias-07--ef33bd8ae7f3adfbdd1362f5f0a3971b.png";